<template>
  <div class="stockApp">
    <div class="stock">
      <Header></Header>
      <main>
        <div class="mainBottom">
          <!-- 左侧菜单栏 -->
          <div class="pharmaLeft_Box">
            <leftNav
              v-show="collapse"
              :navData="navData"
              :defaultProps="defaultProps"
              :default_expanded="default_expanded"
              :leftCurrentNode="leftCurrentNode"
            ></leftNav>
            <div class="title-img" @click="collapseChage">
              <img v-if="collapse" src="../../assets/img/sq.png" alt />
              <img v-else src="../../assets/img/sq.png" alt style="margin:0" />
              <!-- <i v-if="collapse" class="el-icon-d-arrow-left"></i> -->
              <!-- <i v-else class="el-icon-d-arrow-right"></i> -->
            </div>
          </div>
          <!-- 右侧内容 -->
          <div class="right">
            <div class="mainTop">
              <div class="underHeader">
                <img src="../../assets/img/info.png" alt />
                当前位置：
              </div>
              <el-breadcrumb
                separator-class="el-icon-arrow-right"
                style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
              >
                <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
                <el-breadcrumb-item>开放平台</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="main_top">
              <div class="top_left">
                <img src="../../assets/img/kfpt.png" alt />
              </div>
              <div class="top_right">
                <div class="top_right_top">
                  <div class="top_right_box">
                    <div>
                      <h3>宏观经济数据-省级季度数据</h3>
                      <button>API</button>
                    </div>
                  </div>
                  <div class="top_right_box2">信用服务 > 守信激励</div>
                </div>
                <div class="top_right_bottom">
                  <div class="top_bottom_box">
                    <p>
                      价格：
                      <span style="font-size: 14px;">￥</span>
                      <span style="font-size: 26px;font-weight: bold;">25.00</span>
                    </p>
                  </div>
                  <div class="top_bottom_box2">
                    <p>宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。</p>
                  </div>
                  <div class="top_bottom_box3">
                    <span>API套餐：5.00元/50次</span>
                    <span style="margin-left:30px;margin-right:60px;">有效期：240个月</span>
                    <el-button size="mini" type="primary" @click="go">查看更多套餐</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="main_nav">
              <p>API接口</p>
            </div>
            <div class="main_bottom">
              <div class="main_b_l">
                <span>宏观经济数据-省级季度数据</span>
              </div>
              <div class="main_b_r">
                <div class="b_r_box">
                  <div>
                    <p>
                      API名称：宏观经济数据-省级季度数据
                      <span>(datale：19. version：v1.0)</span>
                    </p>
                    <p class="time">最后更新时间：2020年06月20日 15:20:58</p>
                  </div>
                  <div>
                    <p>
                      URL：
                      <span>http://open.drcdaaas.com/geteway/transfer/datasetlnvoking/api?datald=19&version=v1.0</span>
                    </p>
                  </div>
                  <div>
                    <p>请求方式：POST</p>
                  </div>
                </div>
                <div class="b_r_box1">
                  <span>产品介绍</span>
                  <p>宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。</p>
                </div>
                <div class="b_r_box1">
                  <span>使用说明</span>
                  <p>宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）、过敏总收入（GNI）、劳动者报酬、消费水平等等。宏观数据是指一系列的宏观经济学的统计指标经过一定公式计算得到的一个综合指标，包括生产总值（GDP）</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import leftNav from "@/components/leftNav";
import api from "@/../static/common/api/api.js";

export default {
  props: {},
  components: {
    Header,
    Footer,
    leftNav
  },
  data() {
    return {
      collapse: true, //隐藏导航
      leftCurrentNode: 151, //导航默认选中
      navData: [],
      default_expanded: [148],
      defaultProps: {
        children: "childrenList",
        label: "title_name"
      }
    };
  },
  computed: {},

  methods: {
    collapseChage() {
      this.collapse = !this.collapse;
    },
    getPlatformTitle() {
      api.getPlatformTitle().then(res => {
        this.navData = res.data;
      });
    },
    go() {
      window.open("http://open.drcdaas.com/index");
    }
  },
  created() {},
  mounted() {
    this.getPlatformTitle();
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/tableScrollbar.less";
@import "../../assets/less/style.less";
@import "../../assets/less/right.less";
@import "../../assets/less/moreThanThree.less";
.stockApp {
  background: url("../../assets/img/bg.png") no-repeat top;
  display: flex;
}
.stock {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
main {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .right {
    flex: 1;
    height: auto;
    margin-right: 23px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .mainTop {
      display: flex;
      .underHeader {
        display: inline-block;
        height: 54px;
        line-height: 54px;
        padding-left: 19px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #dfecf7;
        img {
          width: 12px;
          height: 16px;
        }
      }
      /deep/ .el-breadcrumb__inner {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #dfecf7;
      }
    }
    .main_top {
      width: 100%;
      background: rgba(5, 43, 79, 0.8);
      border: 1px solid #08396a;
      border-radius: 2px;
      display: flex;
      padding-top: 27px;
      box-sizing: border-box;
      .top_left {
        margin-left: 51px;
        img {
          width: 147px;
          height: 149px;
        }
      }
      .top_right {
        width: 100%;
        display: flex;
        flex-direction: column;
        color: #fff;
        margin-left: 35px;
        padding: 0 20px;
        box-sizing: border-box;
        .top_right_top {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid #08396a;
          .top_right_box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            div {
              display: flex;
              align-items: center;
            }
            h3 {
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #dfecf7;
            }
            button {
              width: 48px;
              height: 17px;
              background: linear-gradient(48deg, #177fe8, #1b9feb);
              border-radius: 2px;
              border: 0;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #dfecf7;
              margin-left: 6px;
            }
          }
          .top_right_box2 {
            margin-top: 15px;
            padding-bottom: 28px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #c6ced9;
          }
        }
        .top_right_bottom {
          display: flex;
          flex-direction: column;
          margin-top: 20px;
          .top_bottom_box {
            p {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #dfecf7;
              span {
                font-family: Arial;

                color: #017fff;
              }
            }
          }
          .top_bottom_box2 {
            margin-top: 10px;
            p {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #c6ced9;
              line-height: 26px;
            }
          }
          .top_bottom_box3 {
            margin-top: 32px;
            padding-bottom: 45px;
            span {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #dfecf7;
              margin-right: 8px;
            }
          }
        }
      }
    }
    .main_nav {
      margin-top: 12px;
      width: 100%;
      height: 48px;
      background: rgba(5, 43, 79, 0.8);
      border: 1px solid #08396a;
      border-radius: 2px 2px 0px 0px;
      padding: 0 20px;
      box-sizing: border-box;
      p {
        word-break: break-all;
        width: 48px;
        line-height: 44px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #dfecf7;
        border-bottom: 1px solid #368ce4;
      }
    }
    .main_bottom {
      width: 100%;
      height: auto;
      display: flex;
      .main_b_l {
        width: 215px;
        background: rgba(5, 43, 79, 0.3);
        border: 1px solid #08396a;
        border-top: none;
        border-radius: 2px 2px 0px 0px;
        text-align: center;
        padding-top: 30px;
        span {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #3c98f5;
        }
      }
      .main_b_r {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;
        background: rgba(5, 43, 79, 0.3);
        border: 1px solid #08396a;
        border-top: none;
        border-left: none;
        border-radius: 0px 2px 2px 0px;
        .b_r_box {
          width: 100%;
          height: 140px;
          border-bottom: 1px solid #08396a;
          padding: 30px 22px 0 37px;
          box-sizing: border-box;
          div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;
            .time {
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #dfecf7;
            }
            p {
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #dfecf7;
              span {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #3c98f5;
              }
            }
          }
        }
        .b_r_box1 {
          width: 100%;
          height: auto;
          padding: 30px 22px 30px 37px;
          box-sizing: border-box;
          border-bottom: 1px solid #08396a;
          span {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #dfecf7;
          }
          p {
            margin-top: 18px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #dfecf7;
            line-height: 26px;
          }
        }
      }
    }
  }

  .mainBottom {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
  }
}
.pharmaLeft_Box {
  display: flex;
}
.title-img {
  img {
    width: 16px;
    height: 54px;
    margin: auto;
    margin-right: 23px;
    margin-left: -16px;
    z-index: 99;
    position: relative;
    // top:50%;
  }
}
</style>
 


// WEBPACK FOOTER //
// src/view/platform/index.vue